import { render } from "./HomeSandesh.vue?vue&type=template&id=6cb89a38"
import script from "./HomeSandesh.vue?vue&type=script&lang=js"
export * from "./HomeSandesh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__